import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

/** Unidades de `theme.spacing` para el padding horizontal de la barra (y referencia para contenido alineado). */
export const STICKY_LIST_DEFAULT_RIGHT_GUTTER = 2;

/**
 * Ancho del bloque de contenido (Card, tabla) bajo la barra sticky.
 * Usa el 100% del contenedor (Header + área principal ya desplazan el drawer);
 * evita `100vw` que desborda respecto al `Header` al 98% y sus márgenes.
 */
export function stickyListRegionWidth(
  _theme: Theme,
  _drawerOpen: boolean,
  _rightGutter: number = STICKY_LIST_DEFAULT_RIGHT_GUTTER,
): string {
  return "100%";
}

type Props = {
  children: React.ReactNode;
  /** Se fusiona con los estilos base (anchura drawer, sticky, etc.) */
  sx?: SxProps<Theme>;
  /** Unidades de `theme.spacing` para padding horizontal (izquierda y derecha). Por defecto 2. */
  rightGutter?: number;
};

/**
 * Barra superior de listados (título + acciones) que permanece visible al hacer scroll.
 * Padding horizontal alineado con el contenido de la Card (p. ej. CardContent).
 */
const StickyListToolbar: React.FC<Props> = ({
  children,
  sx,
  rightGutter = STICKY_LIST_DEFAULT_RIGHT_GUTTER,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        mb: 1,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={[
          {
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
            position: "sticky",
            top: { xs: 56, sm: 64 },
            zIndex: (theme) => theme.zIndex.appBar - 1,
            py: 1,
            px: (theme) => theme.spacing(rightGutter),
            backgroundColor: "background.paper",
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          },
          ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
        ]}
      >
        {children}
      </Box>
    </Box>
  );
};

export default StickyListToolbar;
